// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"CreateEditGroup_loadingOverlay__eBaBd"};